export default __webpack_public_path__ + "static/media/ticket.05bc2bef.svg";